export default __webpack_public_path__ + "static/media/bg-burger.f8d45e46.jpg";